module.exports = __webpack_public_path__ + "img/winerackdog17.959ba7c0.jpg";